import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import Button from 'components/controls/Button';
import _validator from 'modules/validator';
import { routes } from 'routes/Routes';
import _authService from 'modules/AuthService';
import { Spin } from 'antd';
import _notification from 'modules/notification';
import { withRouter } from "react-router";
import { BLACKLISTED_IP_MESSAGE, REGISTRATION_DISABLE } from 'constants/constants';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationID: "",
      applicationIDState: "",
      password: "",
      passwordState: "",
      passwordError: "",
      isLoginSuccess: "",
      isLoading: false,
      isRegistrationEnabled: true,
      registrationDisable:REGISTRATION_DISABLE
    };
    this.homePageLink = React.createRef();
  }

  componentDidMount() {
    //_authService.clearSessionHist();
    this.getIpAddress();
  }

  getIpAddress = async (ev) => {

    this.setState({ isLoading: true });
    try {
      const response = await _authService.getClientIP();

      if (response) {
        this.setState({ isLoading: false, isRegistrationEnabled: true })
      }
      else {
        this.setState({ isLoading: false, isRegistrationEnabled: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  onTextChange = ({ target: { name, value } }) => {
    switch (name) {
      case "applicationID":
        if (_validator.verifyNumber(value)) {
          this.setState({
            [name + "State"]: "success",
            [name + "Error"]: ""
          });
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: "Invalid Application ID"
          });
        }
        break;

      case "password":
        if (_validator.verifyBlank(value)) {
          this.setState({
            [name + "State"]: "success",
            [name + "Error"]: ""
          });
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: "Invalid Password"
          });
        }
        break;

      default:
        this.setState({ [name + "State"]: "success" });
    }
    this.setState({ [name]: value, isLoginSuccess: "" });
  }

  handleLogin = async (ev) => {
    ev.preventDefault();
    if (this.state.applicationIDState === "success" && this.state.passwordState === "success") {
      this.setState({ isLoading: true });
      try {
        const response = await _authService.login({ Application_Id: this.state.applicationID, Password: this.state.password });
        //console.log(response.status);
        if (response.status == 200 && response.data.Application_Id) {
          _authService.setSessionData(response.data);
          window.setTimeout(() => {
            this.setState({ isLoading: false })
            this.homePageLink.current.click();
          }, 3000);
        }
        else {
          this.setState({ isLoading: false })
          _notification.showMessage('error', response.data.Message);
        }
      } catch (e) {
        console.log("te");
        this.setState({ isLoading: false });
      }
    }
    else {
      if (this.state.applicationIDState === "") {
        this.setState({ applicationIDState: "error", applicationIDError: "Invalid Application ID" });
      }
      if (this.state.passwordState === "") {
        this.setState({ passwordState: "error", passwordError: "Invalid Password" });
      }
    }
  }

  // align-items-center m-auto
  render() {
    return (
      <>
        {(this.state.isRegistrationEnabled) &&
          <form onSubmit={this.handleLogin} className="d-flex ml-3 mr-3">
            <div className="login-form-wrap position-relative w-100 form-wrap d-flex justify-content-center">
              <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
                <img alt='image' src={this.props.image} className="projectLogoSizeWidth mb-4 loginMainImageRoundCorner" />
                <div className="login-sec mt-1 w-100">
                  <MyInput
                    wrapClass="mt-2"
                    key="applicationID"
                    type="number"
                    value={this.state.applicationID}
                    name="applicationID"
                    onChange={this.onTextChange}
                    placeholder="Application ID (अर्ज आयडी)"
                    heading={<div className='displayInGrid'><div>Application ID</div><div>अर्ज आयडी</div></div>}
                    isRequired={false}
                    errorState={this.state.applicationIDState}
                    errorMessage={this.state.applicationIDError}
                  />
                  <MyInput
                    wrapClass="mt-2"
                    type="password"
                    value={this.state.password}
                    name="password"
                    onChange={this.onTextChange}
                    placeholder="Enter Password (पासवर्ड टाका)"
                    heading={<div className='displayInGrid'><div>Password</div><div>पासवर्ड</div></div>}
                    isRequired={false}
                    errorState={this.state.passwordState}
                    errorMessage={this.state.passwordError}
                  />
                </div>

                <div className="forget-sec w-100 text-center">
                  <Button
                    type="submit" // style={{ "float": "right" }}
                    className="button-primary mb-3 btn-green w-25 autoHeight"
                    value={<div className='displayInGrid'><div>Login</div><div>लॉगिन करा</div></div>}
                  ></Button>
                  <div className="row w-100 m-0" style={{ display: 'flex', justifyContent: 'center' }}>
                    {this.state.registrationDisable === false &&
                      <div className='displayInGrid' style={{ marginRight: "10px" }}>
                        <a
                          href=""
                          tabIndex="-1"
                          onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.registration.path) }}
                          className="d-block m-t-15 label underline colorOffWhite">
                          New Registration
                        </a>
                        <a
                          href=""
                          tabIndex="-1"
                          onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.registration.path) }}
                          className="d-block m-t-15 label underline colorOffWhite">
                          नवीन नोंदणी
                        </a>
                      </div>
                    }
                    <div className='displayInGrid' style={{ marginLeft: "10px" }}>
                      <a
                        href=""
                        tabIndex="-1"
                        onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.forgotPassword.path) }}
                        className="d-block m-t-15 label underline colorOffWhite">
                        Forgot Password?
                      </a>

                      <a
                        href=""
                        tabIndex="-1"
                        onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.forgotPassword.path) }}
                        className="d-block m-t-15 label underline colorOffWhite">
                        पासवर्ड विसरलात?
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a href={routes.home.basePath} hidden ref={this.homePageLink} onClick={() => { this.props.history.push(routes.home.basePath) }}></a>
            {this.state.isLoading && <Spin size="large" />}
          </form>
        }
        {!this.state.isRegistrationEnabled &&
          <div className="login-form-wrap position-relative w-100 form-wrap d-flex justify-content-center">
            <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
              <img alt='image' src={this.props.image} className="mw120 mb-4 loginMainImageRoundCorner" />
              <label className='blink_me' style={{fontSize: '16px', color: 'red'}}>{BLACKLISTED_IP_MESSAGE}</label>
            </div>
          </div>}
      </>
    );
  }
}

export default withRouter(Login);